import { render, staticRenderFns } from "./voteList.vue?vue&type=template&id=b6240c8a&scoped=true"
import script from "./voteList.vue?vue&type=script&lang=js"
export * from "./voteList.vue?vue&type=script&lang=js"
import style0 from "./voteList.vue?vue&type=style&index=0&id=b6240c8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6240c8a",
  null
  
)

export default component.exports